import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiData } from "../../../actions";
import { _Deals_ } from "../../../Redux/Action/Action";
import DataLoader from "../../../Utils/DataLoader";

export default function ToursSlug() {
  const dispatch = useDispatch();
  const place = useSelector((state) => state.place);

  const [singleData, setSingleData] = useState("");

  const [commonLoader, setCommonLoader] = useState(false);


  const GetInclusiveDealsScript = async () => {
    try {
      setCommonLoader(true);
      const res = await apiData.ToursTravel({ city: place });
      if (res?.status >= 200 && res.status < 400) {

        if (res?.data?.data) {
          setSingleData(res?.data?.data);
        } else {
          setSingleData("");
        }
      }
    } catch (err) {
      console.error("Inclusive script error", err);
      setSingleData("");
    } finally {
      setCommonLoader(false);
    }
  };

  /* ================= SCRIPT LOADER ================= */

  const loadEmbedScript = (src, containerId) => {
    const container = document.getElementById(containerId);
    if (!container) return;

    // SAME AS OLD: always fresh container
    container.innerHTML = "";

    const script = document.createElement("script");
    script.src = src;
    script.async = true;

    script.onerror = () => {
      container.innerHTML =
        `<div class="text-center text-danger fw-bold p-4">Data Not Found</div>`;
    };

    container.appendChild(script);
  };


  /* ================= EFFECTS ================= */

  // Main page embed
  useEffect(() => {
    if (singleData && singleData.includes('"')) {
      const src = singleData.split('"')[1];
      loadEmbedScript(src, "singleData");
    }
  }, [singleData]);


  // Fetch APIs on place change
  useEffect(() => {
    if (!place) return;

    dispatch(_Deals_());
    GetInclusiveDealsScript();
  }, [place, dispatch]);

  /* ================= UI ================= */

  return (
    <>
      {commonLoader ? <DataLoader /> : (
        <div id="singleData"></div>
      )}

    </>
  );
}

